import { makeAutoObservable, runInAction } from 'mobx'
import { Auction } from '../models/Auction'
import agent from '../api/agent'
import { Log } from '../models/Log'
import { store } from './store'
import { ActivityModes } from '../models/modes'
import { Post } from '../models/Post'

type AuctionOrPostOrLog = Auction | Post | Log

export default class MyActivityStore {
  activityRegistry = new Map<string, AuctionOrPostOrLog>()

  constructor() {
    makeAutoObservable(this)

    this.isLogsArray = this.isLogsArray.bind(this)
    this.isLog = this.isLog.bind(this)
  }

  get activity() {
    return Array.from(this.activityRegistry.values())
  }

  loadAuctions = async (mode: ActivityModes) => {
    this.activityRegistry.clear()
    const { formatDateLocal } = store.methodsStore

    let res: AuctionOrPostOrLog[] = []
    if (mode === ActivityModes.wins) {
      const { data: result } = await agent.ActivityPanel.wins()
      res = result
    } else if (mode === ActivityModes.engagement) {
      const { data: result } = await agent.ActivityPanel.participating()
      res = result
    } else if (mode === ActivityModes.myAuctions) {
      const { data: result } = await agent.ActivityPanel.myActivity()
      res = result
    } else if (mode === ActivityModes.logs) {
      const { data: result } = await agent.ActivityPanel.logs()
      res = result
    } else if (mode === ActivityModes.myPosts) {
      const { data: result } = await agent.ActivityPanel.myPosts()
      res = result
    }

    runInAction(() => {
      res.forEach((data) => {
        if (this.isAuction(data)) {
          data.startingDate = new Date(formatDateLocal(data.startingDate))
          data.deadline = new Date(formatDateLocal(data.deadline))
          this.activityRegistry.set(data.id, data)
        } else {
          this.activityRegistry.set(data.id, data)
        }
      })
    })
  }

  isLogsArray(arr: any[]): arr is Log[] {
    return Array.isArray(arr) && arr.every((item) => this.isLog(item))
  }

  isLog(obj: any): obj is Log {
    return typeof obj === 'object' && obj !== null && 'ipAddress' in obj
  }

  isAuction(obj: any): obj is Auction {
    return typeof obj === 'object' && obj !== null && 'roundNumber' in obj
  }

  isPost(obj: any): obj is Post {
    return typeof obj === 'object' && obj !== null && 'rooms' in obj
  }
}
